import { Session } from '/app/utils/auth';
import { config } from '/app/config';
import { redirectTo, currentOrigin } from '/app/utils/navigation';
import { defineAppRouteMiddleware } from '/app/utils/app';

export default defineAppRouteMiddleware((to) => {
	if (!Session.isAuthenticated()) {
		const redirect = `${config.account.url}/gateway`;
		const continueURL = encodeURIComponent(`${currentOrigin()}${to.fullPath}`);
		const [, appName] = location.hostname.split('.').reverse();

		return redirectTo(`${redirect}?continue=${continueURL}&platform=${appName}`);
	}
});
